import { makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { COLORS } from '../../../constants/colors';
import { INPUT } from '../../../constants/props';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

const useStyles = makeStyles({
  root: {
    width: '100%',
    marginBottom: '0.625rem',
  },
  container: {
    display: 'flex',
    backgroundColor: COLORS.grayScale[5],
    overflow: 'hidden',
    borderRadius: '0.3125rem',
    '& input, & textarea': {
      width: '100%',
      fontFamily: 'Raleway',
      fontSize: '1rem',
      lineHeight: '1.1875rem',
      boxSizing: 'border-box',
      border: 'none',
      outline: 'unset',
      color: COLORS.grayScale[1],
      '&::placeholder': {
        color: COLORS.grayScale[4],
      },
    },
    '& > :first-child': {
      marginLeft: '0.3rem',
    },

    '& p': {
      margin: 'auto',
    },

    '& input': {
      color: 'black',
      height: '3.125rem',
      padding: '1.0625rem 1.25rem',
      paddingLeft: 0,
    },
    '& textarea': {
      height: '100%',
      margin: '1.0625rem 1.25rem',
      resize: (props) => props.resize,
    },
  },
  invalid: {
    border: `1px solid ${COLORS.error}`,
    '& *': {
      color: `${COLORS.error} !important`,
      border: 'none',
    },
    // '& > :first-child': {
    //   border: `1px solid ${COLORS.error}`,
    // },
  },
  message: {
    margin: 0,
    marginTop: '0.25rem',
    fontSize: 14,
    lineHeight: 2.1,
    //color: COLORS.error,
  },
  error: {
    color: COLORS.error,
  },
  startIcon: {
    color: COLORS.grayScale[0],
    fontSize: '1.25rem',
    lineHeight: '1.25rem',
    margin: '0.9375rem 1.13rem 0.9375rem 0',
  },
});

const DatePicker = ({
  id,
  className,
  invalid,
  date,
  label,
  textarea,
  resize,
  startIcon,
  onChange,
  format,
  message,
  ...props
}) => {
  const classes = useStyles({ resize });
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} >
      <KeyboardDatePicker
          disableToolbar
          variant="inline"
          format={format?format:"MM/yyyy"} //example "MMMM yyyy"
          views={["year", "month"]}
          id={id ? id : "date-picker-inline_"+label}
          container="inline"
          value={date}
          onChange={onChange}
          //className={classes.container}
          className={`${classes.container} ${invalid?classes.invalid:''}`}
          {...props}
        />
        {message &&
          <Typography variant="caption" className={`${classes.message} ${invalid?classes.error:''}`}>
             {message}
          </Typography>
        }
    </MuiPickersUtilsProvider>
  );
};

DatePicker.defaultProps = {
  className: null,
  startIcon: null,
  invalid: false,
  message: null,
  textarea: false,
  resize: 'auto',
};

DatePicker.propTypes = {
  INPUT,
};

export default DatePicker;
